// extracted by mini-css-extract-plugin
export default {"login-page-container":"Llme2LUDYcxmJpVF5dLm"};